import { H3 } from '@dnb/eufemia';
import { PropsWithChildren, ReactNode } from 'react';

export default function SectionWithTitle({
  title,
  icon = null,
  children,
}: PropsWithChildren<{ title: string; icon?: ReactNode }>) {
  return (
    <div>
      <H3 bottom="small">
        {icon} {title}
      </H3>
      {children}
    </div>
  );
}
